import { useNavigate } from "react-router-dom";
import { trackEntityView } from "../components/shared/JumpBar";

const PAGE_ROUTES = {
  "home": "/", "about": "/about", "auth": "/auth", "dashboard": "/dashboard",
  "lender-portal": "/lender", "investor": "/investor", "admin": "/admin",
  "profile": "/profile", "discovery": "/discovery", "market": "/market",
  "loan-programs": "/loan-programs", "capital-partners": "/capital-partners",
  "apply": "/apply", "contact": "/contact", "terms": "/terms",
  "privacy": "/privacy", "insights": "/insights", "for-lenders": "/for-lenders",
  "for-investors": "/for-investors",
  "founding-members": "/founding-members",
  "secondary-market": "/secondary-market",
  "investor-marketplace": "/investor-marketplace",
  "activity-feed": "/activity-feed",
  "watchlist": "/watchlist",
  "sell": "/sell", "acquisitions": "/acquisitions", "investors": "/investors",
  "risk-disclosure": "/risk-disclosure", "accredited-notice": "/accredited-notice",
  "platform-role": "/platform-role", "underwriting": "/underwriting",
  "capital-matching": "/capital-matching", "funding": "/funding",
};

export function usePageNavigate() {
  const navigate = useNavigate();

  const navigateTo = (pageKey) => {
    const url = PAGE_ROUTES[pageKey];
    if (url) navigate(url);
  };

  const navigateToEntity = (type, id, title) => {
    trackEntityView(type, id, title || `${type} ${(id || "").slice(0, 8)}`);
    navigate(`/entity/${type}/${id}`);
  };

  return { navigateTo, navigateToEntity, navigate };
}
